const tools = require('form/tools')();


exports.config = function (config, types = a => null, language) {

    var urlParameters = tools.getUrlParameters();

    return prepareConfig(config);



    function prepareConfig(config) {
        var parsed = parseConfig(config)
        var injected = injectDefaults(parsed);
        return prepareFields(injected);
    }

    function injectDefaults(config) {
        //const isLeazardIO = ["leazard.io", "leazard-nettbureauas.netdna-ssl.com"].indexOf(location.hostname) !== -1;
        var defaults = {
            //"apiPath": isLeazardIO ? "/api/1" : "/api/2",
            "apiPath": "/api/3",
            "nature": 99,
            // "postUrl": "post.php"
        };

        for (var key in defaults) {
            if (config[key] === undefined) config[key] = defaults[key];
        }

        return config;
    }

    function parseConfig(config) {
        if (typeof config === "string") {
            try {
                return JSON.parse(config);
            }
            catch (error) {
                return JSON.parse(config.slice(5));
            }
        }
        else if (typeof config === "object") return config;
        else throw new Error('Config is not a string or an object');
    }


    function addHoneyPot(fields) {
        var honeypot = config.fields.find(field => {
            return field.type === "honeypot";
        });

        if (honeypot) return fields;
        else return fields.concat({"id": "honeypot", "type": "honeypot"});
    }

    function prepareFields(config) {

        var fields = addHoneyPot(config.fields).map(field => {
            return prepareField(field, config);
        }, {});

        return tools.merge(config, {
            fields
        });
    }


    function prepareField(fieldConfig, completeConfig) {

        var preparators = {
            "api": prepareApi,
            "options": prepareOptions,
            "defaultValue": prepareDefaultValue,
            "validators": prepareValidators
        };


        var valueFromUrl = urlParameters[fieldConfig.id];
        var defaultValue = valueFromUrl || fieldConfig.defaultValue;
        if (defaultValue !== undefined) {
            fieldConfig.defaultValue = defaultValue;
        }

        var mergedConfig = mergeTypeConfig(fieldConfig);

        var prioritizedKeys = Object.keys(mergedConfig).sort((a,b) => {
            return getPriority(a) - getPriority(b);
        });

        return prioritizedKeys.reduce((prepared, key) => {
            if (preparators[key]) {
                prepared[key] = preparators[key](mergedConfig[key], tools.merge(mergedConfig, prepared));
            }
            else prepared[key] = mergedConfig[key];
            return prepared;
        }, {});

        function getPriority(value) {
            var priority = ["options", "defaultValue"];
            var index = priority.indexOf(value);
            return index === -1 ? Infinity : index;
        }

        function prepareValidators(keys, config) {
            var validators = require('form/validators')(language);
            return keys.reduce((list, key) => {
                var [first, error] = key.split(';');
                var [functionName, ...args] = first.split(':');
                var validator = validators[functionName];
                if (validator) return list.concat(validator.apply(null, args.map(evaluateArgument).concat(error)));
                else return list;
            }, []);
        }

        function evaluateArgument(argument) {
            var date = new Date();
            var year = date.getFullYear();
            if (argument.match(/^\([^\)]*\)$/)) {
                return eval(argument);
            }
            else return argument;
        }

        function prepareDefaultValue(defaultValueInput, fieldConfig) {
            var defaultValue = defaultValueInput === null ? null : getDefaultValue(fieldConfig);

            var behaviours = {
                first({options}) {
                    return [options[0].value || options[0]];
                },
                none() {
                    return [];
                },
                all({options}) {
                    return options.map(option => option.value || option);
                }
            };

            var behaviour = behaviours[fieldConfig.defaultValueBehaviour];
            if (defaultValue === null && behaviour) {
                if (fieldConfig.stateType === "array") {
                    return behaviour(fieldConfig);
                }
                else return behaviour(fieldConfig)[0];
            }
            else return defaultValue;
        }

        function getDefaultValue({stateType, defaultValue, options}) {
            var arr = makeArray(defaultValue);
            var valid = validateArray(arr, options);
            if (stateType === "array") {
                return valid;
            }
            else return valid[0];

            function makeArray(defaultValue = []) {
                if (typeof defaultValue === "string") {
                    if (tools.isEnclosedInTags(defaultValue)) {
                        return [defaultValue];
                    }
                    else return defaultValue === "" ? [] : defaultValue.split(',');
                }
                else if (Array.isArray(defaultValue)) {
                    return defaultValue;
                }
                else return [String(defaultValue)];
            }

            function validateArray(array, options) {
                return array.filter(item => {
                    if (options) {
                        return options.find(option => (option.value || option) == item);
                    }
                    else return true;
                });
            }
        }

        function prepareOptions(options) {
            return options.reduce((list, option) => {
                return list.concat(parseOption(option));
            }, []);

        }

        function prepareApi(apiConfig) {
            if (apiConfig && apiConfig.url === undefined) {
                var relativePath = combine("/", completeConfig.apiPath, mergedConfig.type);
                var apiKey = tools.getUrlParameters()["key"] || completeConfig.apiKey;
                if (apiKey) {
                    var base = "https://leazard.io";
                    apiConfig.url = base + relativePath + "?key=" + apiKey;
                }
                else {
                    apiConfig.url = relativePath;
                }
            }
            return apiConfig;
        }
    }


    function mergeTypeConfig(config) {
        var type = types(config.type);
        if (type) {
            return tools.merge(type.config, config);
        }
        else return config;
    }


    function combine(separator, ...parts) {
        if (parts.length === 1) return parts[0];
        else if (parts.length === 0) return "";
        else {
            var separated = addSeparator(separator, parts[0]);
            return separated + combine.apply(null, [separator, ...parts.slice(1)]);
        }

        function addSeparator(separator, text) {
            if (text.match(separator + "$")) return text;
            else return text + separator;
        }
    }
};

function parseOption(option) {
    if (Array.isArray(option)) {
        var [start, stop, step, suffix] = option;
        function range(start, stop, step, suffix) {
            return tools.range(start, stop, step).map(optionWithSuffix.bind(null, suffix));
        }
        if (typeof step === "string") return range(start, stop, undefined, step);
        return range(start, stop, step, suffix);
    }
    else if (typeof option === "object") {
        if (option.display !== undefined) return option;
        else return tools.merge(option, {display: option.value});
    }
    else return {value: option, display: option};
}

function optionWithSuffix(suffix, value) {
    return {
        value: value,
        display: value + (suffix ? " " + suffix : "")
    };
}

